import React from 'react';
import { Link } from '@/components/LocaleLink';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { homeCopy } from '@/contexts/language/translations/pages/home';

const AudienceSplitSection = () => {
  const { language } = useLanguage();
  const c = homeCopy[language].audience;

  const AUDIENCES = [
    { id: 'profit', ...c.profit, href: '/our-work/digital-cfo' },
    { id: 'data', ...c.data, href: '/our-work/data-engineering' },
  ];

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container-custom max-w-5xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-block px-4 py-2 rounded-lg bg-foreground text-white text-xs font-semibold mb-6">
            {c.badge}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {c.title}
          </h2>
          <p className="text-muted-foreground">
            {c.text}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {AUDIENCES.map((audience) => (
            <div key={audience.id} className="rounded-2xl border border-gray-100 bg-[#FAFAFA] p-8 flex flex-col">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF6B35] mb-4">
                {audience.label}
              </span>
              <h3 className="text-xl md:text-2xl font-bold text-foreground mb-3">{audience.title}</h3>
              <p className="text-muted-foreground mb-6 flex-1">{audience.body}</p>
              <Link
                to={audience.href}
                className="inline-flex items-center gap-2 text-[#FF6B35] font-semibold hover:gap-3 transition-all"
              >
                {audience.cta}
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AudienceSplitSection;
